import TableAuditAssessmentLog from "@/modules/tables/TableAuditAssessmentLog";
import TableAuditTestSectionLogs from "@/modules/tables/TableAuditTestSectionLogs";

export default function Audit({ isAdmin }: { isAdmin: boolean }) {
  return (
    <div>
      <TableAuditAssessmentLog />
      {isAdmin && <TableAuditTestSectionLogs />}
    </div>
  );
}
